{
	"id": 7506,
	"moduleNumber": 6,
	"slug": "module-6",
	"kgNodeId": "module-6",
	"title": "The Professional Educator and Technology",
	"subtitle": "Apply ethical judgment with technology, maintaining boundaries, transparency, and student welfare.",
	"type": "lesson",
	"moduleKind": "standard",
	"moduleKindLabel": "Lesson",
	"sourceStatus": "module_list_only",
	"summary": "Module 6 is reserved for ethical technology use in education, including digital conduct, data privacy, accessibility, and the educator's professional responsibilities when technology affects student learning and welfare.",
	"estimatedDurationMinutes": 35,
	"activityCount": 2,
	"knowledgeCheck": {
		"included": true,
		"questionCount": 5
	},
	"learningObjectives": [
		"Identify ethical risks created by technology use in school settings.",
		"Evaluate digital conduct, privacy, and access concerns through the educator ethics framework.",
		"Select actions that protect student welfare and preserve public trust."
	],
	"flow": [
		"Technology-focused ethical scenario.",
		"Perspective review.",
		"Ethical reflection and decision analysis.",
		"Knowledge-check or practice items when source content is added."
	],
	"scenarios": [],
	"ethicalSituations": [],
	"sources": {
		"moduleList": "../../../../.working/Praxis ProEthics/Content/ProEthica Module List/ProEthica 2.0_Complete Module List.docx",
		"primary": null,
		"scorm": null,
		"transcripts": [],
		"videos": []
	}
}
